import React, { useEffect, useState } from 'react'
import logo from '../assets/images/lovedripp.png';
import artDimension from '../assets/images/lovecouple.png';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { login, reset } from '../reduxAuth/authSlice';
import './login.css';

function LoginScreen() {
  
    const dispatch                                              = useDispatch();
    const { isLoading, isError, isSuccess, user, message}     = useSelector((state) => state.auth);

    const navigate                                            = useNavigate();
    
    const [formData, setFormData]                             = useState({
            companycode: "",
            password: "",
     });
  
    useEffect(() => {
        if (isError) {
            toast.error(message || "Login failed");
        }

        if (isSuccess && user) {
            toast.success("Login successful");
            navigate('/'); 
        }

        return () => dispatch(reset());
    }, [isError, isSuccess, user, message, dispatch]);


    const onChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
        ...prev,
        [name]: value,
        }));
    };
    
    const onSubmit = (e) => {
        e.preventDefault();
        dispatch(login(formData));
    };

    
  return (
    <div
      className="log-body">
        <div className="row">
            <div className="col-md-7">
                <div className="login-phase">
                    <div className="logo-outline">                       
                        <img src={logo} className="logo-part"/>
                    </div>
                    <div className="login-form-outline mb-3">
                        <form onSubmit={onSubmit}>
                            <div className="mb-3">
                                <label for="email" className="form-label">Email address</label>
                                <input 
                                    type="email" 
                                    className="form-control"
                                    name="email"
                                    value={formData.email}
                                    onChange={onChange}
                                    required/>                             
                            </div>
                            <div className="mb-3">
                                <label for="password" className="form-label">Password</label>
                                <input type="password" className="form-control"
                                  name="password"
                                  value={formData.password}
                                  onChange={onChange} 
                                  required/>
                            </div>
                       
                            <button type="submit" className="btn btn-primary">Submit</button>
                        </form>
                       
                    </div>
                    
                </div>
            </div>
            <div className="col-md-5">
                <div className="position-outline-image">
                    <div className="position-inline-image">
                        <img src={artDimension} className="shade-logo" alt="Couple Lovedripp" />
                    </div>                        
                </div>
            </div>
        </div>
    </div>
  )
}

export default LoginScreen